import { Component } from '@angular/core';

@Component({
  selector: 'app-mock-data-notice',
  templateUrl: './mock-data-notice.component.html',
  styleUrls: ['./mock-data-notice.component.scss'],
  standalone: false,
})
export class MockDataNoticeComponent {}